import React from 'react';
import './policy-info-header.scss';
import PolicyStatusLabel from '../../../../shared/policy-status-display/policy-status-label';
import { VersionLabel } from '../../../../../utils/enums';
import { formatMonthInSort } from '../../../../../utils/datesUtils';

interface PolicyInfoHeaderProps {
    connection: {
        policyStatus?: VersionLabel;
        policyVersionNumber: number;
        formattedPolicyApplyDate?: string;
        policyApplyDate?: Date;
        policyName?: string;
    };
}

const PolicyInfoHeader: React.FC<PolicyInfoHeaderProps> = ({ connection }) => (
    <div className="policy-info-header">
        {!!connection.policyStatus && <PolicyStatusLabel label={connection.policyStatus} versionNumber={connection.policyVersionNumber} />}
        <span className="policy-name">{connection.policyName}</span>
        <span className="apply-date">{connection.formattedPolicyApplyDate ? formatMonthInSort(connection.policyApplyDate) : ''}</span>
    </div>
);

export default PolicyInfoHeader;
